import { networkUrl } from '@/utils/network.utils'
import domains from '@/utils/networkConfig'
const APIs = {
  websiteUrl: {
    summaryExam: '/records/summary/:id',
    answerboardExam: '/records/answerboard'
  }
}
export default networkUrl(APIs, domains)
